import React from 'react';
import EventForm from './form';
import {normalizer} from './pipeline';
import {addEventItem} from '../../modules/Api';
import {notification} from 'antd';

class AddEvent extends React.Component {
    constructor() {
        super();
        this.state = {
            submitted: false
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer(values);
        addEventItem(formData, () => {
            notification.open({
                message: `رویداد اضافه شد!`,
                description: `رویداد ثبت شد. می توانید آن را در لیست رویداد ها مشاهده کنید و در صورت نیاز ویرایش کنید.`
            });
            this.setState({submitted: false});
        });
    }
    render() {
        return (<div><EventForm submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddEvent;


// WEBPACK FOOTER //
// ./src/containers/Events/add.js